import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import axios from "axios";
import NavBar from "../../components/NavBar/NavBar";
import DeviceTable from "../../components/Tables/DeviceTable";
import DeviceForm from "../../components/Forms/DeviceForm";

const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL;

const DevicePage = ({auth, onLogout}) => {
    const [devices, setDevices] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchDevices = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}/devices`, {
                headers: { Authorization: `Bearer ${auth.token}` }
            });
            // console.log("Fetched Devices:", response.data);
            setDevices(response.data);
            setError(null);
        } catch (error) {
            if (error.response?.status === 401) {
                onLogout(); // onLogout for 401 errors
            } else {
                setError(error.response?.data?.message || "Failed to load devices. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (auth.token) {
            fetchDevices();
        } else {
            setError("Authentication token missing");
            setLoading(false);
        }
    }, [auth.token]);

    // Open the modal for adding a new device
    const handleAddNewDevice = () => {
        setSelectedDevice(null);
        setShowModal(true);
    };

    // Open the modal for editing a device
    const handleEditDevice = (device) => {
        setSelectedDevice(device);
        setShowModal(true);
    };

    // Close the modal
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSaveDevice = async (device) => {
        try {
            const headers = { Authorization: `Bearer ${auth.token}` };

            if (device.id) {
                // Update existing device
                const response = await axios.put(`${API_BASE_URL}/devices/${device.id}`, device, { headers });

                setDevices((prevDevices) =>
                    prevDevices.map((d) =>
                        d.id === device.id ? response.data.device[0] : d
                    )
                );
            } else {
                // Add new device to the list
                const response = await axios.post(`${API_BASE_URL}/devices`, device, { headers });
                setDevices((prevDevices) => [
                    ...prevDevices,
                    response.data.device,
                ]);
            }
            handleCloseModal();
        } catch (error) {
            if (error.response?.status === 401) {
                onLogout(); // onLogout for 401 errors
            } else {
                setError(error.response?.data?.message || "Failed to save device. Please try again.");
            }
        }
    };

    return (
        <>
            <NavBar auth={auth} onLogout={onLogout} />
            <Container fluid className="my-4">
                {error && <div className="alert alert-danger">{error}</div>}
                <DeviceTable
                    devices={devices}
                    loading={loading}
                    onEditDevice={handleEditDevice}
                    onAddNewDevice={handleAddNewDevice}
                />
                <DeviceForm
                    selectedDevice={selectedDevice}
                    onSave={handleSaveDevice}
                    showModal={showModal}
                    handleCloseModal={handleCloseModal}
                    auth={auth}
                    onLogout={onLogout}
                />
            </Container>
        </>
    );
};

export default DevicePage;